import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileMenu.css';

function ProfileMenu({ currentUser, onClose, onLogout, showTierAndUpgrade = true }) {
  const navigate = useNavigate();

  const handleNavigation = (section) => {
    onClose();
    navigate('/settings', { state: { scrollTo: section } });
  };

  return (
    <>
      {/* Backdrop */}
      <div className="profile-menu-backdrop" onClick={onClose}></div>

      {/* Profile Menu Popup */}
      <div className="profile-menu-popup">
        <div className="profile-menu-header">
          <div className="profile-avatar">
            <i className="fas fa-user-circle"></i>
          </div>
          <div className="profile-user-info">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <h3>{currentUser?.username || 'User'}</h3>
              {!currentUser?.isAdmin && showTierAndUpgrade && (
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    background:
                      currentUser?.tier === 'Free'
                        ? '#cbd5e1'
                        : currentUser?.tier === 'Business'
                          ? '#f59e0b'
                          : '#2563eb',
                    color: 'white',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                  }}
                >
                  {(currentUser?.tier || 'Free').toUpperCase()}
                </span>
              )}
            </div>
            <p>{currentUser?.email || ''}</p>
          </div>
        </div>

        <div className="profile-menu-divider"></div>

        {/* Menu List */}
        <div className="profile-menu-list">
          {!currentUser?.isAdmin && showTierAndUpgrade && (
            <button
              className="profile-menu-item"
              onClick={() => {
                onClose();
                navigate('/subscription');
              }}
            >
              <i className="fas fa-gem"></i>
              <span>Update Tier</span>
            </button>
          )}

          <button
            className="profile-menu-item"
            onClick={() => {
              onClose();
              navigate('/settings');
            }}
          >
            <i className="fas fa-cog"></i>
            <span>Settings</span>
          </button>

          {!currentUser?.isAdmin && (
            <button
              className="profile-menu-item"
              onClick={() => {
                onClose();
                navigate('/help');
              }}
            >
              <i className="far fa-question-circle"></i>
              <span>Help Center</span>
            </button>
          )}

          <div className="profile-menu-divider"></div>

          <button
            className="profile-menu-item logout"
            onClick={() => {
              onClose();
              onLogout();
            }}
          >
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default ProfileMenu;
